import React, { Component } from "react";

import "../../App.css";

// import { deleteEvent } from '../services/userServices'

import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";

import { IconButton } from "@material-ui/core";

import { Card } from "@material-ui/core";
// import history from '../history';

import history from "../../history";

import { MenuItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";

import DialogTitle from "@material-ui/core/DialogTitle";

import DialogContent from "@material-ui/core/DialogContent";

import DialogActions from "@material-ui/core/DialogActions";

import { DeleteShows } from "../../services/userServices";
import * as io from "socket.io-client";
import { builtinModules } from "module";

export default class CardCompShows extends Component {
  constructor(props) {
    super(props);
    this.state = {
      click: false,
      trash: false,
      fetchShows: {},
      color: ""
    };
    this.handleOpenDialog = this.handleOpenDialog.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
  }
  data = e => {
    if (e.target.id) {
      history.push("/editPage", e.target.id);
      // this.props.history.push('/editPage', { Display: this.props.Display, noteKey: this.props.noteKey })
      this.props.navigation.navigate("/editPage", e.target.id);
    }
  };
  componentDidMount() {
    const { endpoint } = this.state;
    // const socket = io('http://104.248.187.179:5000');
      // const socket = io('https://167.172.222.187');
    // const socket = io("192.168.0.170:5000");
    const socket = io("https://chrom.tryoncourse.com/");
    var AlComp = this.props.Display;
    // console.log(socket);
    // let Myid = sessionStorage.getItem("MyID");
    let Myid = "6WftVYP1rINB3HGa2ZJy";
    // console.log(Myid);
    socket.on("connect", data => {
      socket.emit("joinEvent", Myid);
      socket.on("newUser", user => {
        socket.on(Myid, data => {
          // console.log( "#" + data[AlComp.section] ,AlComp.section);
          this.setState({ color: "#" + data[AlComp.section] });
        });
      });
    });
  }
  trash = () => {
    var data = this.props.Display.id;

    DeleteShows(data)
      .then(response => {
        // console.log("response", response);
        setTimeout(() => {
          this.setState({
            fetchShows: response,
            openSnackBar: true,
            snackBarMessage: "Deleted Successfully"
          });
          window.location.href = "/ShowsPage";
        }, 500);

        // console.log("fetchShows", this.state.fetchShows);
      })
      .catch(error => {
        console.log(error);
      });
  };

  handleOpenDialog() {
    this.setState({
      openDialog: true
    });
  }
  handleCloseDialog() {
    this.setState({
      openDialog: false
    });
  }

  render() {
    return (
      <div onClick={this.data.bind(this)} location={this.props.location}>
        <div style={{margin: '0 10px'}}>
          <div className="myCardClassShowsDiv">
            <div>
              <div
                style={{
                  fontSize: 25,
                  fontWeight: "bold",
                  color: "black",
                  textAlign: "center"
                }}
              >
                {/* <p>File Name</p>
                                    {/* <p>{this.prop.Display.}</p> 

                                    <img src={require('../../assets/images.jpeg')}
                                        alt='ShowImage'
                                        style={{ width: '50px', height: '50px' }}
                                    /> */}
                <div
                  className="preview"
                  style={{ backgroundColor: this.state.color }}
                ></div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {/* <label>Show Name</label> */}
              <label style={{ fontWeight: "bold" }}>
                {" "}
                {this.props.Display.section}{" "}
              </label>
            </div>

            <div>
              {/* <Button colored onClick={this.handleOpenDialog} raised ripple> */}
              {/* <MenuItem
                                    id=""
                                // trash={this.handleTrash.bind(this)}>
                                // onClick={this.data.bind(this)}
                                // onClick={this.trash}
                                > */}
              <img
                src={require("../../assets/delete-24px.svg")}
                onClick={this.handleOpenDialog}
                // alt='DeleteIcon'
                alt="DeleteIconShows"
                id=""
                title="Click to delete"
              />
              {/* </MenuItem> */}

              {/* </Button> */}

              <Dialog
                open={this.state.openDialog}
                onCancel={this.handleCloseDialog}
              >
                <DialogTitle>Delete??</DialogTitle>
                <DialogContent>
                  <p> Are you sure you want to delete this item </p>
                </DialogContent>
                <DialogActions>
                  <Button type="button" color="secondary" onClick={this.trash}>
                    Delete
                  </Button>
                  <Button
                    type="button"
                    color="primary"
                    onClick={this.handleCloseDialog}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          open={this.state.openSnackBar}
          autoHideDuration={6000}
          onClose={this.handleSnackClose}
          variant="error"
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={<span id="message-id"> {this.state.snackBarMessage} </span>}
          action={[
            <div>
              <IconButton
                key="close"
                aria-label="Close"
                onClick={this.handleSnackClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          ]}
        />
      </div>
    );
  }
}

// <div className="Icons">
// <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >

// <button
//     className="eraseDefault"
//     colored
//     onClick={this.handleOpenDialog} raised ripple>

//     <img
//         // src={require('../assets/delete-24px.svg')}
//         src={require('../../assets/delete-24px.svg')}
//         alt='DeleteIcon'
//         id=""
//         title='Click to delete'
//     />

// </button>

// <Dialog open={this.state.openDialog} onCancel={this.handleCloseDialog}>
//     <DialogTitle>Delete??</DialogTitle>
//     <DialogContent>
//         <p>  Are you sure you want to delete this item </p>
//     </DialogContent>
//     <DialogActions>
//         <Button type="button"
//             color='secondary'
//             onClick={this.trash}>
//             Delete
//             </Button>
//         <Button type="button" color='primary' onClick={this.handleCloseDialog}>
//             Cancel
//             </Button>
//     </DialogActions>
// </Dialog>
// </div>
// </div>
